var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_808",
    "data-name": "Group 808",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.789,
    height: 29.5,
    viewBox: "0 0 23.789 29.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    width: 23.789,
    height: 29.5,
    fill: "#0082ca"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5353",
    "data-name": "Path 5353",
    d: "M23.784,6.41c0-.41.012-.82,0-1.225A1.654,1.654,0,0,0,22.62,3.622L13.2.35c-.282-.1-.561-.2-.845-.286a2.3,2.3,0,0,0-1.509.194L1.157,3.622A1.66,1.66,0,0,0,0,5.184V15.372a10.894,10.894,0,0,0,.614,3.582A15.626,15.626,0,0,0,4.635,25a21.882,21.882,0,0,0,5.79,4.01c.232.111.473.218.754.332a1.494,1.494,0,0,0,.633.158c.071,0,.153,0,.252-.012l.251-.023a2.4,2.4,0,0,0,.334-.138,21.609,21.609,0,0,0,5.868-3.745A16.155,16.155,0,0,0,22.786,19.9a11.9,11.9,0,0,0,.958-3.71,15.178,15.178,0,0,0,.037-1.531l0-.4ZM5.352,20.921l-.136-.188a12.326,12.326,0,0,1-1.285-2.248,9.623,9.623,0,0,1-.593-2.116,14.78,14.78,0,0,1-.066-1.651V6.361L11.9,3.369l8.62,2.991v8.16a16.787,16.787,0,0,1-.065,1.833,9.484,9.484,0,0,1-.59,2.127,11.838,11.838,0,0,1-1.1,1.988c-.111.169-.227.334-.42.578l-.2.246c-.267.324-.551.639-.842.943A18.849,18.849,0,0,1,15.349,24l-.254.188c-.166.123-.337.246-.515.367-.339.232-.684.455-1.033.666a17.813,17.813,0,0,1-1.626.865,19.742,19.742,0,0,1-3.481-2.1L8.4,23.954l-.028-.02-.251-.2c-.161-.131-.324-.266-.487-.409-.319-.279-.633-.568-.93-.868s-.585-.608-.857-.925c-.13-.151-.261-.306-.38-.463M12,28.869Z",
    transform: "translate(0 0)",
    fill: "#0082ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5354",
    "data-name": "Path 5354",
    d: "M6.953,13.695l.465.465a1.022,1.022,0,0,0,1.426,0l2.3-2.3,3.635-3.633.84-.839a1.01,1.01,0,0,0-1.428-1.428l-2.3,2.3L8.254,11.893l-.123.125L5.588,9.474l-.467-.465a1.009,1.009,0,0,0-1.426,1.428l3.258,3.258",
    transform: "translate(2.25 3.746)",
    fill: "#0082ca"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIconBlue);
export default __webpack_public_path__ + "static/media/security-icon-blue.bd31fe26eac646532a7f873ccb7b19de.svg";
export { ForwardRef as ReactComponent };